var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "content-wrap",
    class: _vm.swiperLowClass,
    style: _vm.backgroundStyle,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleContentClick.apply(null, arguments);
      }
    }
  }, [_vm.firstLowImg || _vm.imgList && _vm.imgList.length ? _c('div', {
    staticClass: "swiper-con",
    style: {
      height: _vm.swiperConHeight + 'px'
    }
  }, [_c('div', {
    staticClass: "swiper-container",
    class: 'swiper-con-' + _vm.dataIndex
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.imgList, function (item, i) {
    return _c('div', {
      key: i,
      class: ['swiper-slide', i === 0 ? 'space-compress' : '']
    }, [i === 0 ? _c('img', {
      attrs: {
        "src": _vm.imgSrc,
        "alt": "",
        "draggable": "false"
      },
      on: {
        "load": _vm.handleImgLoad,
        "error": _vm.handleError
      }
    }) : _vm._e(), i === 1 ? _c('img', {
      attrs: {
        "src": item.src,
        "alt": "",
        "draggable": "false"
      },
      on: {
        "error": _vm.handleError
      }
    }) : _vm._e(), i >= 2 && i < _vm.preLoadIndex ? _c('img', {
      attrs: {
        "src": item.src,
        "alt": "",
        "draggable": "false"
      },
      on: {
        "error": _vm.handleError
      }
    }) : _vm._e()]);
  }), 0)]), _vm.imgList && _vm.imgList.length && _vm.imgList.length > 1 ? _c('div', {
    staticClass: "paginate-points"
  }, [_c('div', {
    ref: "pointsContainer",
    staticClass: "points-container"
  }, _vm._l(_vm.imgList, function (item, i) {
    return _c('span', {
      key: 'point' + i,
      staticClass: "point-normal",
      class: {
        'point-small': _vm.lastShowIndex > 4 && _vm.lastShowIndex - 4 >= i || _vm.firstShowIndex + 4 <= i && i < _vm.imgList.length - 1,
        'point-active': _vm.swiper_index - 1 === i
      }
    });
  }), 0)]) : _vm._e(), _vm.imgList.length && _vm.firstFeedFinish ? _c('div', {
    staticClass: "swiper-image-number"
  }, [_vm._v(" " + _vm._s(_vm.swiper_index) + "/" + _vm._s(_vm.imgList.length) + " ")]) : _vm._e(), _vm.jumpIconShow ? _c('div', {
    staticClass: "jump-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconUrl
    }
  })]) : _vm._e()]) : _vm._e(), _vm.likeAnmStatus && _vm.dataIndex === _vm.currentIndex && !_vm.newBtnIcon ? _c('likeAnimation', {
    staticClass: "likeAnimation",
    attrs: {
      "like-client-x": _vm.likeClientX,
      "like-client-y": _vm.likeClientY
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };